import { msg } from 'gt-react';
import { TrayIcon } from '@phosphor-icons/react';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { Route as pathlessAuthenticatedRoute } from '../route';
import { inboxSearchSchema } from './hooks/use-inbox-search-params';

const InboxPage = lazyRouteComponent(() => import('./InboxPage'));
const InboxErrorComponent = lazyRouteComponent(
  () => import('./InboxPage'),
  'InboxErrorComponent',
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/inbox',
  staticData: {
    app: {
      nav: {
        label: msg('Inbox', {
          context: 'sidebar nav label, Overview section',
        }),
        icon: <TrayIcon className="h-4 w-4" weight="fill" />,
        group: 'Overview',
        order: 5,
        groupOrder: 1,
        pinned: true,
      },
      access: {
        featureFlag: 'inbox-enabled',
      },
    },
  },
  component: InboxPage,
  errorComponent: InboxErrorComponent,
  loader: () => ({
    crumb: msg('Inbox', { context: 'page breadcrumb' }),
  }),
  validateSearch: inboxSearchSchema,
});
